export const SITE_ACCESS_STATUS = {
  CHECKING: "CHECKING",
  ACCESSIBLE: "ACCESSIBLE",
  FORBIDDEN: "FORBIDDEN",
  UNAVAILABLE: "UNAVAILABLE",
  UNKNOWN: "UNKNOWN",
};

export const SITE_ACCESS_MESSAGES = {
  [SITE_ACCESS_STATUS.CHECKING]: {
    title: "Checking Access",
    text: "",
  },
  [SITE_ACCESS_STATUS.FORBIDDEN]: {
    title: "You Don't Have Access To This Site",
    text: "Contact your SharePoint administrator to request access.",
  },
  [SITE_ACCESS_STATUS.UNAVAILABLE]: {
    title: "This Site Is Unavailable",
    text: "It may have been removed, or you may not have permission to access it. Contact your SharePoint administrator.",
  },
  [SITE_ACCESS_STATUS.UNKNOWN]: {
    title: "Access Could Not Be Checked",
    text: "SharePoint did not answer. Try again in a moment.",
  },
};

export const SHAREPOINT_ERROR_CODES = {
  POLICY_CHANGED: "SHAREPOINT_POLICY_CHANGED",
  SITE_NOT_ALLOWED: "SHAREPOINT_SITE_NOT_ALLOWED",
  AUTH_REQUIRED: "SHAREPOINT_AUTH_REQUIRED",
};

export const SITE_NOT_ALLOWED_MESSAGE =
  "This site is not allowed by your workspace administrator.";
export const NO_ALLOWED_SITES_MESSAGE = "No Sites Have Been Allowed";
export const NO_ALLOWED_SITES_EXPLANATION =
  "Your workspace administrator has not allowed any SharePoint sites yet. Contact them to request access.";

export const LOAD_MORE_FAILED_MESSAGE = "Could Not Load More Results";

export const isSiteBlocked = (item, restricted = false) => {
  if (item?.type !== "site") {
    return false;
  }
  if (!item.accessStatus) {
    return restricted;
  }
  return item.accessStatus !== SITE_ACCESS_STATUS.ACCESSIBLE;
};

export const isNonAdvancingCursor = (pagination, usedOffset) =>
  Boolean(pagination?.hasMore) &&
  String(pagination.nextStartRow ?? "") === String(usedOffset ?? "");

export const SITE_PROVENANCE = {
  browse: "browse",
  search: "search",
  policy: "policy",
};
